// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 차수별현황 화면 */

/* ── 알림 아이콘 ── */
.turn-alert-wrap {
  display: inline-block;
  cursor: pointer;
  margin-left: 2px;
  vertical-align: middle;
  line-height: 1;
}
.turn-alert-icon { font-size: 10px; }
.turn-alert-none  { opacity: 0.35; }
.turn-alert-gte   { color: #2e7d32; }
.turn-alert-lte   { color: #c62828; }
.turn-alert-both  { color: #e65100; }
/* 활성/비활성 통합 상태 */
.turn-alert-on  { color: #52a8ec; opacity: 1; }
.turn-alert-off { color: #aaa;    opacity: 0.5; }

/* ── 필터 영역 ── */
.turn-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* ── 조건 구분선 ── */
.turn-sep {
  display: inline-block;
  width: 1px;
  height: 16px;
  background: #ccc;
  margin: 0 4px;
  flex-shrink: 0;
  align-self: center;
}

/* ── 수동 시세갱신 버튼 ── */
.turn-refresh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: white;
  font-size: 15px;
  cursor: pointer;
  color: #555;
  margin-left: 4px;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;
  transition: color 0.2s, border-color 0.2s;
}

.turn-refresh-btn:hover:not(:disabled) {
  color: #3050c8;
  border-color: #3050c8;
}

.turn-refresh-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.turn-refresh-btn.spinning {
  animation: turn-spin 1s linear infinite;
}

@keyframes turn-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ── 매도완료포함 체크박스 ── */
.turn-chk {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.turn-chk input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

/* ── 바디 ── */
.turn-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  gap: 8px;
}

/* ── 표시모드 버튼 행 ── */
.turn-mode-row {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.turn-mode-btn {
  padding: 4px 14px;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  color: #555;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.1s, color 0.1s, border-color 0.1s;
}

.turn-mode-btn.active {
  background: #3050c8;
  color: white;
  border-color: #3050c8;
}

.turn-mode-btn:hover:not(.active) { background: #f0f4ff; }

/* ── 시세 상태 표시 ── */
.turn-price-status {
  margin-left: 8px;
  font-size: 11px;
}

.turn-price-status.loading  { color: #888; }
.turn-price-status.realtime { color: #0a8a00; }
.turn-price-status.mixed    { color: #888; }

/* ── 자동갱신 체크박스 (모드 행 오른쪽 끝) ── */
.auto-refresh-chk {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 10px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: #7dbb7d;
  border: 1px solid #b8ddb8;
  background: #f4fbf4;
  white-space: nowrap;
  transition: color 0.2s, border-color 0.2s, background 0.2s;
}

.auto-refresh-chk input[type="checkbox"] {
  cursor: pointer;
  accent-color: #2e7d32;
}

.auto-refresh-chk.active {
  color: #1b5e20;
  border-color: #4caf50;
  background: #e8f5e9;
  font-weight: 600;
}

.auto-refresh-chk.fetching {
  color: #2e7d32;
  animation: turn-refresh-pulse 1.2s ease-in-out infinite;
}

@keyframes turn-refresh-pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.45; }
}

/* ── 컬럼 리사이즈 핸들 ── */
.col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.col-resize-handle:hover {
  background: rgba(0, 0, 0, 0.15);
}

/* ── 그리드 래퍼: 가로·세로 스크롤 ── */
.turn-grid-wrapper {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid #dde2ef;
  border-radius: 4px;
  background: white;
}

/* ── 그리드 공통 ── */
.turn-grid td {
  font-size: 12px;
  white-space: nowrap;
}

/* ── 좌측 고정 헤더 ── */
.turn-grid .th-freeze-left {
  position: sticky;
  z-index: 3;
  background: #f0f2f8;
}

/* ── 우측 고정 헤더 ── */
.turn-grid .th-freeze-right {
  position: sticky;
  right: 0;
  z-index: 3;
  background: #f0f2f8;
  border-left: 2px solid #d0d5e8 !important;
  text-align: left !important;
}

/* ── 좌측 고정 데이터 셀 ── */
.turn-grid .td-freeze-left {
  position: sticky;
  z-index: 2;
  background: white;
}

/* ── 우측 고정 데이터 셀 ── */
.turn-grid .td-freeze-right {
  position: sticky;
  right: 0;
  z-index: 2;
  background: white;
  border-left: 2px solid #d0d5e8 !important;
}

/* 합계 마지막 컬럼(수익률) 우측 구분선 */
.th-summary-last,
.td-summary-last {
  border-right: 2px solid #d0d5e8 !important;
}

/* 전체매도완료 행: sticky 셀 배경 연회색 */
.row-all-sold .td-freeze-left,
.row-all-sold .td-freeze-right {
  background: #f2f2f2;
}

/* 호버: 일반 행 */
.row-active:hover .td-freeze-left,
.row-active:hover .td-freeze-right {
  background: #f5f7ff;
}

/* 호버: 전체매도 행 */
.row-all-sold:hover .td-freeze-left,
.row-all-sold:hover .td-freeze-right {
  background: #ebebeb;
}

/* ── 컬럼별 패딩·스타일 ── */
.td-account {
  padding: 5px 8px !important;
  font-size: 11px;
  color: #555;
}

.td-term {
  font-size: 11px;
  color: #555;
}

.td-sector {
  padding: 5px 8px !important;
  font-size: 11px;
  color: #555;
}

.td-name {
  padding: 5px 10px !important;
}

.stock-name-text {
  font-weight: 600;
  font-size: 12px;
  color: #1a1a2e;
  line-height: 1.3;
}

.stock-ticker-text {
  font-size: 10px;
  color: #888;
  line-height: 1.2;
  margin-top: 1px;
}

/* ── 현재가 셀 ── */
.col-right {
  text-align: right !important;
}

.th-price,
.td-price {
  font-size: 12px;
  font-weight: 600;
  padding-right: 8px !important;
  color: #1a1a2e;
}

/* ── 등락 셀 ── */
.td-diff {
  font-size: 11px;
  font-weight: 600;
  padding: 5px 4px !important;
}

/* ── 비고 셀 ── */
.td-memo {
  padding: 5px 10px !important;
  font-size: 11px;
  color: #444;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── 차수 컬럼 헤더 ── */
.th-turn {
  font-size: 12px;
  text-align: center !important;
}

/* ── 차수 데이터 셀 ── */
.td-turn {
  padding: 5px 6px !important;
  font-size: 12px;
  cursor: default;
}

/* ── 정렬 헤더 ── */
.sortable-th {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.sortable-th:hover { background: #e0e4f0 !important; }

.sort-icon { margin-left: 3px; font-size: 10px; }
.sort-idle   { opacity: 0.35; }
.sort-active { opacity: 1; color: #3050c8; }
.sort-col-active { color: #1a3ab8; }

/* ── 합계 컬럼 헤더 ── */
.th-summary {
  background: #eaecf5 !important;
  font-size: 11px;
  text-align: right !important;
  padding-right: 8px !important;
}

/* ── 합계 데이터 셀 ── */
.td-summary {
  font-size: 12px;
  padding: 5px 8px !important;
  white-space: nowrap;
}

/* ── 미매도 행 ── */
.row-active { background: white; }
.row-active:hover { background: #f5f7ff !important; }

/* ── 전체 매도완료 행 ── */
.row-all-sold { background: #f2f2f2; color: #888; }
.row-all-sold:hover { background: #ebebeb !important; }
.row-all-sold .stock-name-text { color: #888; }

/* ── 미매도 차수 셀 (매도 팝업) ── */
.td-turn-sell {
  cursor: pointer;
}
.td-turn-sell:hover { background: #fff3f3 !important; }

/* ── 빈 차수 셀 (매수 팝업) ── */
.td-turn-buy {
  cursor: pointer;
}
.td-turn-buy:hover { background: #f0f5ff !important; }

/* ── 오렌지 셀 (다음 매수 예상 수익률) ── */
.td-turn-orange {
  cursor: default;
  background: #fff8f0;
}
.td-turn-orange:hover { background: #fff3e0 !important; }

/* ── 팝업 공통 ── */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-box {
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  width: 440px;
  max-width: 96vw;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.popup-title {
  padding: 13px 18px;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid #dde2ef;
}

.popup-title.sell-title { background: #fff0f0; color: #c00000; }
.popup-title.buy-title  { background: #f0f5ff; color: #1a3ab8; }

.popup-body {
  padding: 12px 18px;
  overflow-y: auto;
  flex: 1 1;
}

.popup-form { width: 100%; border-collapse: collapse; }

.popup-form th {
  text-align: right;
  padding: 5px 10px 5px 0;
  font-size: 12px;
  color: #555;
  font-weight: 600;
  width: 90px;
  white-space: nowrap;
  vertical-align: middle;
}

.popup-form td { padding: 4px 0; vertical-align: middle; }
.popup-divider { height: 6px; }

.popup-input {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  box-sizing: border-box;
  font-family: inherit;
  background: white;
}

.popup-input.readonly  { background: #f5f5f5; color: #555; cursor: default; border-color: #e0e0e0; }
.popup-input.right     { text-align: right; }
.popup-input.profit-pos { color: #cc0000; font-weight: 600; }
.popup-input.profit-neg { color: #0000cc; font-weight: 600; }

.popup-error {
  color: #cc0000;
  font-size: 12px;
  margin-top: 8px;
  padding: 6px 10px;
  background: #fff0f0;
  border-radius: 4px;
  border: 1px solid #ffcccc;
}

.popup-footer {
  padding: 10px 18px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/status/TurnStatusPage.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb,iBAAiB;AACjB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA,mBAAmB,eAAe,EAAE;AACpC,oBAAoB,aAAa,EAAE;AACnC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,iBAAiB;AACjB,kBAAkB,cAAc,EAAE,UAAU,EAAE;AAC9C,kBAAkB,WAAW,KAAK,YAAY,EAAE;;AAEhD,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD,mBAAmB;AACnB;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B,WAAW,EAAE;AAC3C,8BAA8B,cAAc,EAAE;AAC9C,8BAA8B,WAAW,EAAE;;AAE3C,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,aAAa,EAAE;AAC7B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;;EAEE,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;;EAEE,mBAAmB;AACrB;;AAEA,aAAa;AACb;;EAEE,mBAAmB;AACrB;;AAEA,eAAe;AACf;;EAEE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB,8BAA8B,EAAE;;AAErD,aAAa,gBAAgB,EAAE,eAAe,EAAE;AAChD,eAAe,aAAa,EAAE;AAC9B,eAAe,UAAU,EAAE,cAAc,EAAE;AAC3C,mBAAmB,cAAc,EAAE;;AAEnC,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB,cAAc,iBAAiB,EAAE;AACjC,oBAAoB,8BAA8B,EAAE;;AAEpD,oBAAoB;AACpB,gBAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sBAAsB,8BAA8B,EAAE;AACtD,iCAAiC,WAAW,EAAE;;AAE9C,2BAA2B;AAC3B;EACE,eAAe;AACjB;AACA,sBAAsB,8BAA8B,EAAE;;AAEtD,yBAAyB;AACzB;EACE,eAAe;AACjB;AACA,qBAAqB,8BAA8B,EAAE;;AAErD,+BAA+B;AAC/B;EACE,eAAe;EACf,mBAAmB;AACrB;AACA,wBAAwB,8BAA8B,EAAE;;AAExD,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA,cAAc,WAAW,EAAE,yBAAyB,EAAE;;AAEtD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,iBAAiB,cAAc,EAAE,sBAAsB,EAAE;AACzD,iBAAiB,WAAW,EAAE;;AAE9B;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,yBAAyB,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACnG,yBAAyB,iBAAiB,EAAE;AAC5C,0BAA0B,cAAc,EAAE,gBAAgB,EAAE;AAC5D,0BAA0B,cAAc,EAAE,gBAAgB,EAAE;;AAE5D;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX","sourcesContent":["/* 차수별현황 화면 */\n\n/* ── 알림 아이콘 ── */\n.turn-alert-wrap {\n  display: inline-block;\n  cursor: pointer;\n  margin-left: 2px;\n  vertical-align: middle;\n  line-height: 1;\n}\n.turn-alert-icon { font-size: 10px; }\n.turn-alert-none  { opacity: 0.35; }\n.turn-alert-gte   { color: #2e7d32; }\n.turn-alert-lte   { color: #c62828; }\n.turn-alert-both  { color: #e65100; }\n/* 활성/비활성 통합 상태 */\n.turn-alert-on  { color: #52a8ec; opacity: 1; }\n.turn-alert-off { color: #aaa;    opacity: 0.5; }\n\n/* ── 필터 영역 ── */\n.turn-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* ── 조건 구분선 ── */\n.turn-sep {\n  display: inline-block;\n  width: 1px;\n  height: 16px;\n  background: #ccc;\n  margin: 0 4px;\n  flex-shrink: 0;\n  align-self: center;\n}\n\n/* ── 수동 시세갱신 버튼 ── */\n.turn-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  background: white;\n  font-size: 15px;\n  cursor: pointer;\n  color: #555;\n  margin-left: 4px;\n  line-height: 1;\n  padding: 0;\n  flex-shrink: 0;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.turn-refresh-btn:hover:not(:disabled) {\n  color: #3050c8;\n  border-color: #3050c8;\n}\n\n.turn-refresh-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.turn-refresh-btn.spinning {\n  animation: turn-spin 1s linear infinite;\n}\n\n@keyframes turn-spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* ── 매도완료포함 체크박스 ── */\n.turn-chk {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #333;\n  cursor: pointer;\n  user-select: none;\n}\n\n.turn-chk input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n\n/* ── 바디 ── */\n.turn-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  gap: 8px;\n}\n\n/* ── 표시모드 버튼 행 ── */\n.turn-mode-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.turn-mode-btn {\n  padding: 4px 14px;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  color: #555;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.1s, color 0.1s, border-color 0.1s;\n}\n\n.turn-mode-btn.active {\n  background: #3050c8;\n  color: white;\n  border-color: #3050c8;\n}\n\n.turn-mode-btn:hover:not(.active) { background: #f0f4ff; }\n\n/* ── 시세 상태 표시 ── */\n.turn-price-status {\n  margin-left: 8px;\n  font-size: 11px;\n}\n\n.turn-price-status.loading  { color: #888; }\n.turn-price-status.realtime { color: #0a8a00; }\n.turn-price-status.mixed    { color: #888; }\n\n/* ── 자동갱신 체크박스 (모드 행 오른쪽 끝) ── */\n.auto-refresh-chk {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 10px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  cursor: pointer;\n  user-select: none;\n  color: #7dbb7d;\n  border: 1px solid #b8ddb8;\n  background: #f4fbf4;\n  white-space: nowrap;\n  transition: color 0.2s, border-color 0.2s, background 0.2s;\n}\n\n.auto-refresh-chk input[type=\"checkbox\"] {\n  cursor: pointer;\n  accent-color: #2e7d32;\n}\n\n.auto-refresh-chk.active {\n  color: #1b5e20;\n  border-color: #4caf50;\n  background: #e8f5e9;\n  font-weight: 600;\n}\n\n.auto-refresh-chk.fetching {\n  color: #2e7d32;\n  animation: turn-refresh-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes turn-refresh-pulse {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.45; }\n}\n\n/* ── 컬럼 리사이즈 핸들 ── */\n.col-resize-handle {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.col-resize-handle:hover {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n/* ── 그리드 래퍼: 가로·세로 스크롤 ── */\n.turn-grid-wrapper {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  border: 1px solid #dde2ef;\n  border-radius: 4px;\n  background: white;\n}\n\n/* ── 그리드 공통 ── */\n.turn-grid td {\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* ── 좌측 고정 헤더 ── */\n.turn-grid .th-freeze-left {\n  position: sticky;\n  z-index: 3;\n  background: #f0f2f8;\n}\n\n/* ── 우측 고정 헤더 ── */\n.turn-grid .th-freeze-right {\n  position: sticky;\n  right: 0;\n  z-index: 3;\n  background: #f0f2f8;\n  border-left: 2px solid #d0d5e8 !important;\n  text-align: left !important;\n}\n\n/* ── 좌측 고정 데이터 셀 ── */\n.turn-grid .td-freeze-left {\n  position: sticky;\n  z-index: 2;\n  background: white;\n}\n\n/* ── 우측 고정 데이터 셀 ── */\n.turn-grid .td-freeze-right {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  background: white;\n  border-left: 2px solid #d0d5e8 !important;\n}\n\n/* 합계 마지막 컬럼(수익률) 우측 구분선 */\n.th-summary-last,\n.td-summary-last {\n  border-right: 2px solid #d0d5e8 !important;\n}\n\n/* 전체매도완료 행: sticky 셀 배경 연회색 */\n.row-all-sold .td-freeze-left,\n.row-all-sold .td-freeze-right {\n  background: #f2f2f2;\n}\n\n/* 호버: 일반 행 */\n.row-active:hover .td-freeze-left,\n.row-active:hover .td-freeze-right {\n  background: #f5f7ff;\n}\n\n/* 호버: 전체매도 행 */\n.row-all-sold:hover .td-freeze-left,\n.row-all-sold:hover .td-freeze-right {\n  background: #ebebeb;\n}\n\n/* ── 컬럼별 패딩·스타일 ── */\n.td-account {\n  padding: 5px 8px !important;\n  font-size: 11px;\n  color: #555;\n}\n\n.td-term {\n  font-size: 11px;\n  color: #555;\n}\n\n.td-sector {\n  padding: 5px 8px !important;\n  font-size: 11px;\n  color: #555;\n}\n\n.td-name {\n  padding: 5px 10px !important;\n}\n\n.stock-name-text {\n  font-weight: 600;\n  font-size: 12px;\n  color: #1a1a2e;\n  line-height: 1.3;\n}\n\n.stock-ticker-text {\n  font-size: 10px;\n  color: #888;\n  line-height: 1.2;\n  margin-top: 1px;\n}\n\n/* ── 현재가 셀 ── */\n.col-right {\n  text-align: right !important;\n}\n\n.th-price,\n.td-price {\n  font-size: 12px;\n  font-weight: 600;\n  padding-right: 8px !important;\n  color: #1a1a2e;\n}\n\n/* ── 등락 셀 ── */\n.td-diff {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 5px 4px !important;\n}\n\n/* ── 비고 셀 ── */\n.td-memo {\n  padding: 5px 10px !important;\n  font-size: 11px;\n  color: #444;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── 차수 컬럼 헤더 ── */\n.th-turn {\n  font-size: 12px;\n  text-align: center !important;\n}\n\n/* ── 차수 데이터 셀 ── */\n.td-turn {\n  padding: 5px 6px !important;\n  font-size: 12px;\n  cursor: default;\n}\n\n/* ── 정렬 헤더 ── */\n.sortable-th {\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.sortable-th:hover { background: #e0e4f0 !important; }\n\n.sort-icon { margin-left: 3px; font-size: 10px; }\n.sort-idle   { opacity: 0.35; }\n.sort-active { opacity: 1; color: #3050c8; }\n.sort-col-active { color: #1a3ab8; }\n\n/* ── 합계 컬럼 헤더 ── */\n.th-summary {\n  background: #eaecf5 !important;\n  font-size: 11px;\n  text-align: right !important;\n  padding-right: 8px !important;\n}\n\n/* ── 합계 데이터 셀 ── */\n.td-summary {\n  font-size: 12px;\n  padding: 5px 8px !important;\n  white-space: nowrap;\n}\n\n/* ── 미매도 행 ── */\n.row-active { background: white; }\n.row-active:hover { background: #f5f7ff !important; }\n\n/* ── 전체 매도완료 행 ── */\n.row-all-sold { background: #f2f2f2; color: #888; }\n.row-all-sold:hover { background: #ebebeb !important; }\n.row-all-sold .stock-name-text { color: #888; }\n\n/* ── 미매도 차수 셀 (매도 팝업) ── */\n.td-turn-sell {\n  cursor: pointer;\n}\n.td-turn-sell:hover { background: #fff3f3 !important; }\n\n/* ── 빈 차수 셀 (매수 팝업) ── */\n.td-turn-buy {\n  cursor: pointer;\n}\n.td-turn-buy:hover { background: #f0f5ff !important; }\n\n/* ── 오렌지 셀 (다음 매수 예상 수익률) ── */\n.td-turn-orange {\n  cursor: default;\n  background: #fff8f0;\n}\n.td-turn-orange:hover { background: #fff3e0 !important; }\n\n/* ── 팝업 공통 ── */\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.popup-box {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);\n  width: 440px;\n  max-width: 96vw;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.popup-title {\n  padding: 13px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  border-bottom: 1px solid #dde2ef;\n}\n\n.popup-title.sell-title { background: #fff0f0; color: #c00000; }\n.popup-title.buy-title  { background: #f0f5ff; color: #1a3ab8; }\n\n.popup-body {\n  padding: 12px 18px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.popup-form { width: 100%; border-collapse: collapse; }\n\n.popup-form th {\n  text-align: right;\n  padding: 5px 10px 5px 0;\n  font-size: 12px;\n  color: #555;\n  font-weight: 600;\n  width: 90px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.popup-form td { padding: 4px 0; vertical-align: middle; }\n.popup-divider { height: 6px; }\n\n.popup-input {\n  width: 100%;\n  padding: 5px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  box-sizing: border-box;\n  font-family: inherit;\n  background: white;\n}\n\n.popup-input.readonly  { background: #f5f5f5; color: #555; cursor: default; border-color: #e0e0e0; }\n.popup-input.right     { text-align: right; }\n.popup-input.profit-pos { color: #cc0000; font-weight: 600; }\n.popup-input.profit-neg { color: #0000cc; font-weight: 600; }\n\n.popup-error {\n  color: #cc0000;\n  font-size: 12px;\n  margin-top: 8px;\n  padding: 6px 10px;\n  background: #fff0f0;\n  border-radius: 4px;\n  border: 1px solid #ffcccc;\n}\n\n.popup-footer {\n  padding: 10px 18px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
